import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateBeforeCallsImportantInfo } from '../../../../actions/waitingArea.js';
import { updateShowWaitingAreaBeforeCallsImportantInfoModal } from '../../../../actions/modal.js';

export default function RightPanelTop(props) {
  const dispatch = useDispatch();
  const [updatingBeforeCallsDetail, setUpdatingBeforeCallsDetail] = useState(false);

  const updateBeforeCallImportantInfo = (e) => {
    setUpdatingBeforeCallsDetail(true);

    let beforeCallsImportantInfoForm = props.beforeCallsImportantInfoForm;
    let cb = (requestSuccessful) => {
      setUpdatingBeforeCallsDetail(false);
      dispatch(updateShowWaitingAreaBeforeCallsImportantInfoModal(!requestSuccessful));
    };

    let beforeCallsImportantInfoValue = props.beforeCallsImportantInfoForm.importantInfo.ifTextEmpty
      ? ''
      : props.beforeCallsImportantInfoForm.importantInfo.value;
    dispatch(updateBeforeCallsImportantInfo(props.waitingArea.id, beforeCallsImportantInfoValue, cb));
  };

  const cancelUpdateBeforeCalls = () => {
    dispatch(updateShowWaitingAreaBeforeCallsImportantInfoModal(false));
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="ui actions mrbl max-width">
          <button
            type="button"
            onClick={updateBeforeCallImportantInfo}
            className={updatingBeforeCallsDetail ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" />
          </button>
          <button
            type="button"
            onClick={cancelUpdateBeforeCalls}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="ui actions mrbl max-width mrtxxs ">
          <button
            onClick={cancelUpdateBeforeCalls}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
}
